/**
 * Created by Ning Jiang on 4/27/2016.
 */

import { IPunkInitData } from "./PunkServerData";
import { ParsedInitData } from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import { PunkServerDataParser } from "../PunkServerDataParser";
import {
    FeatureBuyTimesBetValue
} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
export class PunkParsedInitData extends ParsedInitData {

    private readonly _gameAreaSize:number[];

    private readonly _scatterReelPositions:number[];
    private readonly _wildReelPositions:number[];
    private readonly _mysteryReelPositions:number[];

    private readonly _mysterySym:string;
    private readonly _respinTriggered:boolean;

    private readonly _initData:boolean = true;

    public get isInitData():boolean{
        return this._initData;
    }

    public get scatterReelPositions():number[] {
        return this._scatterReelPositions;
    }

    public get respinTriggered():boolean{
        return this._respinTriggered;
    }

    public get wildReelPositions():number[] {
        return this._wildReelPositions;
    }

    public get mysteryReelPositions():number[] {
        return this._mysteryReelPositions;
    }
    
    public get mysterySym():string {
        return this._mysterySym;
    }

    public get gameAreaSize():number[] {
        return this._gameAreaSize;
    }

    private readonly _featureBuyTimesBetValue:FeatureBuyTimesBetValue[];
    public get featureBuyTimesBetValue():FeatureBuyTimesBetValue[] {
        return this._featureBuyTimesBetValue;
    }

    private readonly _accumulatedRoundWin:string;
    public get accumulatedRoundWin():string {
        return this._accumulatedRoundWin;
    }

    constructor(rawData:IPunkInitData, dataParser:PunkServerDataParser) {
        super(rawData, dataParser);

        this._respinTriggered  = !!rawData.respinTriggered;

        this._gameAreaSize = dataParser.parseRGameAreaSize(rawData);
        this._scatterReelPositions = this.findOneSymbol("S");
        this._wildReelPositions = this.findOneSymbol("W");
        this._mysteryReelPositions = this.findOneSymbol("M");
        this._mysterySym = dataParser.parsemysterySymbolRevealed(rawData);
        this._featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
        this._accumulatedRoundWin = rawData.accumulatedRoundWin;
    }

    private findOneSymbol(symbol:string):number[]{
        let arr:number[] = [];

        const skipOverflowBott:number = 1;
        for(let reel = 0; reel < this.reels.length; reel++){
            let pos:number = -1;
            for(let row = skipOverflowBott; row < 3 + skipOverflowBott; row++){
                if(this.reels[reel][row] == symbol){
                    pos = row-skipOverflowBott;
                    break;
                } 
            }
            arr.push(pos);
        }
        return arr;
    }

    protected parseScatterPositions(rawData:IPunkInitData, dataParser:PunkServerDataParser):number[] | undefined {
        return dataParser.parseScatterPositionsEnteringFreespin(rawData);
    }
}